import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ComponentPropsExtenderSymbol } from 'feature-components'
import { Wixapps } from './wixapps'

export const page: ContainerModuleLoader = (bind) => {
	bind(ComponentPropsExtenderSymbol).to(Wixapps)
}
